import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/http-api';
import { Schema } from 'effect';
import { BadRequestError, InternalServerError } from './errors';
import { SchemaUtils } from './schema-utils';

const SubmitContactPayload = Schema.Struct({
  email: SchemaUtils.Email,
  phone: Schema.String.pipe(Schema.check(Schema.isMinLength(7))),
});

const SubmitContactResponse = Schema.Struct({
  ticketId: Schema.Int,
});

// DEPRECATED: superseded by the provider-neutral `BusinessContact.Submit`
// endpoint (`POST /api/business-contact`), which routes to Chatwoot instead of
// Zendesk. Kept temporarily so in-flight clients don't break; remove once all
// callers have migrated.
const submitContactEndpoint = HttpApiEndpoint.post(
  'SubmitContact',
  '/contact',
  {
    payload: SubmitContactPayload,
    success: SubmitContactResponse.pipe(HttpApiSchema.status(200)),
    error: [BadRequestError, InternalServerError],
  },
)
  .annotate(OpenApi.Summary, 'Submit Business Contact (deprecated)')
  .annotate(
    OpenApi.Description,
    'DEPRECATED — use POST /api/business-contact. Submits a business lead inquiry as a Zendesk support ticket.',
  )
  .annotate(OpenApi.Deprecated, true);

export const zendeskGroup = HttpApiGroup.make('Zendesk')
  .add(submitContactEndpoint)
  .prefix('/zendesk');
